import { parseQueryFromLocation } from '../../routing/operators/parseQueryFromLocation';
export const getVerifyInstall = location => parseQueryFromLocation(location).verifyInstall;